<template>
  <div
    class="_component-welfare"
    :class="{ hide: !$store.state.isShowWelfare }"
    v-if="$store.state.Deadline.rdDiff !== Infinity && !$store.getters.isRdOver"
  >
    <div class="content-wrap">
      <div class="icon-close" @click="handleClickClose"></div>
      <div class="text-1 h3">完善信息后解锁《名校早知道》精华视频</div>
      <p class="text2 color-white">
        了解诺奖教授和哈佛学霸的Secret of Success<br />
        添加峰会小助手解锁福利，第一时间获取峰会相关动态
      </p>
      <div class="qr-wrap img-wrap pc-only" v-if="!modal">
        <img src="//hsylc.oss-cn-hangzhou.aliyuncs.com/2026/qr/qr-5.png" alt="" />
      </div>
      <!-- <p class="text3 color-white-50">* 视频链接将通过短信发放</p>
      <div class="text-1 h3 mt-10">填写完成申请表后</div>
      <p class="text2 color-white mt-10">
        《哈佛幸福心理课》独家硬核干货<br />
        哈佛学霸【学习狠招+生活秘籍】播客<br />
        等你来解锁！
      </p> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'Welfare',
  props: {
    modal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClickClose() {
      this.$store.commit('triggerWelfare');
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
